/*
 * Public API Surface of algolia
 */

export * from './lib/algolia.service';
export * from './lib/mat-algolia.module';
export * from './lib/directives/mat-algolia-refresh.directive.js';
export * from './lib/components';
